/**
 * Browser shim for `node:module`, aliased in vite.config.ts.
 *
 * `@fume/core` is frozen and its libsodium backend does:
 *
 *     import { createRequire } from 'node:module';
 *     const require = createRequire(import.meta.url);
 *     const sodium = require('libsodium-wrappers-sumo');
 *     await sodium.ready;
 *
 * `node:module` does not exist in the browser, so we alias it to this file. Our
 * `createRequire` returns a `require` that resolves exactly the one module core
 * asks for — the reviewed WASM build of libsodium — and nothing else. This lets
 * the frozen core run unmodified in the browser bundle.
 */
import sodium from 'libsodium-wrappers-sumo';

export function createRequire(_from?: string | URL): (id: string) => unknown {
  return (id: string): unknown => {
    if (id === 'libsodium-wrappers-sumo') {
      return sodium;
    }
    throw new Error(`node:module browser shim: unsupported require(${JSON.stringify(id)})`);
  };
}

export default { createRequire };
